module.exports = __webpack_public_path__ + "img/photos.460b646b.svg";